module.exports = __webpack_public_path__ + "img/bg.2d33b694.png";